import { useState, useCallback } from "react";
import axios from "axios";
import { message as antMessage } from 'antd';  
import AuthContext from '../store/AuthContext';
import ChatContext from '../store/ChatContext';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
const useHttp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const auth = useContext(AuthContext);
  const chatCtx = useContext(ChatContext);
  const history = useHistory();
  
  const sendRequest = useCallback(
    async ({ url, method, headers = {}, params = null, data = null, timeout = 180000, onResponse, onError, showLoader = true, resetIdleTimeout = true }) => {
      setLoading(true);
      if (showLoader !== false) {
        auth.setDisplaySpinner(true);//change it to increase the spinner
      }
      setError(null);

      const source = axios.CancelToken.source();
        axios.defaults.withCredentials = true; //cookie support
    
      // Add CSRF token to headers if available
      const requestHeaders = {
        ...headers,
        ...(chatCtx.token && { 'X-CSRF-TOKEN': chatCtx.token })
      };
    
      const requestConfig = {
        url,
        method,
        headers: requestHeaders,
        params,
        data,
        timeout,
        cancelToken: source.token,
      };

      try {
        const response = await axios(requestConfig);
        // const headers = response.headers;
        // const csrfToken = headers.get('X-CSRF-TOKEN');  
       
       
        if(history && response.request.responseURL.includes(`/app/login`) && !url.includes(`/getClientAttributes`)){
          //   window.location.href = `${systemConfig?.EXCHANGE_BASE_URL}/${profile}${systemConfig?.['saml.logout.url']}`;
          console.log("session expired" , url);
          antMessage.error('Session expired, please login again');
          history.push("/login");
          return;
          }
       
        if (onResponse) {
          onResponse(response.data);
        }
        return response.data; 
      } catch (err) {
        if (history &&  err?.response?.status === 403 && !url.includes(`/validateUser`)) {
          antMessage.error({
            content: 'Multiple sessions found for the user, please login again',
            duration: 1
          });
          history.push("/login");
          return;
        }
        if (history &&  err?.response?.status === 401  && !url.includes(`/validateUser`)) {
          antMessage.error('Session expired, please login again');
          history.push("/login");
          return;
        }
        if (axios.isCancel(err)) {
          console.warn("Request canceled:", err.message);
        } else {
          setError(err);
          if (onError) {
            onError(err);
          } else {
            antMessage.error('Something went wrong');
          }
        }
        // throw err; 
      } finally {
        setLoading(false);
        if (showLoader !== false) { 
          auth.setDisplaySpinner(false);//change it to decrease the spinner
        }
      }
    },
    [chatCtx.token, auth, history]
  );

  // Method for GET requests
  const getRequest = useCallback(
    async ({ url, headers, params, timeout, onResponse, onError,showLoader, resetIdleTimeout = true }) => {
      const requestHeaders = {
        ...headers,
        ...(chatCtx.token && { 'X-CSRF-TOKEN': chatCtx.token })
      };
      return sendRequest({
        url,
        method: "GET",
        headers: requestHeaders,
        params,
        timeout,
        onResponse,
        onError,
        showLoader,
        resetIdleTimeout
      });
    },
    [sendRequest, chatCtx.token]
  );

  // Method for POST requests
  const postRequest = useCallback(
    async ({ url, headers, params, data, timeout, onResponse, onError,showLoader, resetIdleTimeout = true }) => {
      const requestHeaders = {
        ...headers,
        ...(chatCtx.token && { 'X-CSRF-TOKEN': chatCtx.token })
      };
      return sendRequest({
        url,
        method: "POST",
        headers: requestHeaders,
        params,
        data,
        timeout,
        onResponse,
        onError,
        showLoader,
        resetIdleTimeout
      });
    },
    [sendRequest, chatCtx.token]
  );

  // Method for PUT requests
  const putRequest = useCallback(
    async ({ url, headers, params, data, timeout, onResponse, onError,showLoader, resetIdleTimeout = true }) => {
      const requestHeaders = {
        ...headers,
        ...(chatCtx.token && { 'X-CSRF-TOKEN': chatCtx.token })
      };
      return sendRequest({
        url,
        method: "PUT",
        headers: requestHeaders,
        params,
        data,
        timeout,
        onResponse,
        onError,
        showLoader,
        resetIdleTimeout
      });
    },
    [sendRequest, chatCtx.token]
  );

  return { loading, error, getRequest, postRequest, putRequest };
};

export default useHttp;